export default {
	"STUDENTTEXT": {
		5: "MAIN_CONTENT.ChangeStudentData.householdPhone",
		6: "MAIN_CONTENT.ChangeStudentData.studentAddressLineOne",
		7: "MAIN_CONTENT.ChangeStudentData.studentAddressLineTwo",
		8: "MAIN_CONTENT.ChangeStudentData.studentAddressCity",
		9: "MAIN_CONTENT.ChangeStudentData.studentAddressState",
		10: "MAIN_CONTENT.ChangeStudentData.studentAddressZip",
		11: "MAIN_CONTENT.ChangeStudentData.studentAddressZipExtend",
		26: "MAIN_CONTENT.ChangeStudentData.residentOfCounty",
		42: "MAIN_CONTENT.ChangeStudentData.studentEmailAddress",
		74: "MAIN_CONTENT.ChangeStudentData.householdPhoneEmergencyCallOrder",
		87: "MAIN_CONTENT.ChangeStudentData.township",
		182: "MAIN_CONTENT.ChangeStudentData.studentPhone",
		183: "MAIN_CONTENT.ChangeStudentData.studentPhoneType",
		184: "MAIN_CONTENT.ChangeStudentData.canSendVoiceMessages",
		185: "MAIN_CONTENT.ChangeStudentData.canSendTextMessages",
		186: "MAIN_CONTENT.ChangeStudentData.isPhoneUnlisted"
	},
	"CONTACTSTEXT": {
		17: "MAIN_CONTENT.ChangeStudentData.firstName",
		18: "MAIN_CONTENT.ChangeStudentData.lastName",
		19: "MAIN_CONTENT.ChangeStudentData.phoneOne",
		20: "MAIN_CONTENT.ChangeStudentData.phoneTwo",
		21: "MAIN_CONTENT.ChangeStudentData.phoneThree",
		116: "MAIN_CONTENT.ChangeStudentData.addressLineOne",
		117: "MAIN_CONTENT.ChangeStudentData.addressLineTwo",
		118: "MAIN_CONTENT.ChangeStudentData.addressCity",
		119: "MAIN_CONTENT.ChangeStudentData.addressCounty",
		120: "MAIN_CONTENT.ChangeStudentData.state",
		121: "MAIN_CONTENT.ChangeStudentData.zipCode",
		122: "MAIN_CONTENT.ChangeStudentData.zipCodeExtension",
		126: "MAIN_CONTENT.ChangeStudentData.emailAddressOne",
		127: "MAIN_CONTENT.ChangeStudentData.employer",
		128: "MAIN_CONTENT.ChangeStudentData.phoneTwoExtension",
		131: "MAIN_CONTENT.ChangeStudentData.contactLivesWithStudent",
		132: "MAIN_CONTENT.ChangeStudentData.middleName",
		137: "MAIN_CONTENT.ChangeStudentData.occupation",
		139: "MAIN_CONTENT.ChangeStudentData.phoneOneEmergencyCallOrder",
		140: "MAIN_CONTENT.ChangeStudentData.phoneOneExtension",
		141: "MAIN_CONTENT.ChangeStudentData.phoneTwoEmergencyCallOrder",
		143: "MAIN_CONTENT.ChangeStudentData.phoneThreeEmergencyCallOrder",
		144: "MAIN_CONTENT.ChangeStudentData.phoneThreeExtension",
		148: "MAIN_CONTENT.ChangeStudentData.title",
		149: "MAIN_CONTENT.ChangeStudentData.township",
		151: "MAIN_CONTENT.ChangeStudentData.phoneFour",
		152: "MAIN_CONTENT.ChangeStudentData.phoneFourType",
		153: "MAIN_CONTENT.ChangeStudentData.phoneFourExtension",
		154: "MAIN_CONTENT.ChangeStudentData.phoneFourNumberUnlisted",
		155: "MAIN_CONTENT.ChangeStudentData.phoneFourCanSendVoiceMessages",
		156: "MAIN_CONTENT.ChangeStudentData.phoneFourCanSendTextMessages",
		157: "MAIN_CONTENT.ChangeStudentData.phoneFive",
		158: "MAIN_CONTENT.ChangeStudentData.phoneFiveType",
		159: "MAIN_CONTENT.ChangeStudentData.phoneFiveExtension",
		160: "MAIN_CONTENT.ChangeStudentData.phoneFiveNumberUnlisted",
		161: "MAIN_CONTENT.ChangeStudentData.phoneFiveCanSendVoiceMessages",
		162: "MAIN_CONTENT.ChangeStudentData.phoneFiveCanSendTextMessages",
		163: "MAIN_CONTENT.ChangeStudentData.phoneThreeType",
		164: "MAIN_CONTENT.ChangeStudentData.phoneThreeNumberUnlisted",
		165: "MAIN_CONTENT.ChangeStudentData.phoneThreeCanSendVoiceMessages",
		166: "MAIN_CONTENT.ChangeStudentData.phoneThreeCanSendTextMessages",
		167: "MAIN_CONTENT.ChangeStudentData.phoneFiveEmergencyCallOrder",
		168: "MAIN_CONTENT.ChangeStudentData.phoneFourEmergencyCallOrder",
		169: "MAIN_CONTENT.ChangeStudentData.phoneTwoType",
		170: "MAIN_CONTENT.ChangeStudentData.phoneTwoNumberUnlisted",
		171: "MAIN_CONTENT.ChangeStudentData.phoneTwoCanSendVoiceMessages",
		172: "MAIN_CONTENT.ChangeStudentData.phoneTwoCanSendTextMessages",
		173: "MAIN_CONTENT.ChangeStudentData.phoneOneType",
		174: "MAIN_CONTENT.ChangeStudentData.phoneOneNumberUnlisted",
		175: "MAIN_CONTENT.ChangeStudentData.phoneOneCanSendVoiceMessages",
		176: "MAIN_CONTENT.ChangeStudentData.phoneOneCanSendTextMessages",
		177: "MAIN_CONTENT.ChangeStudentData.emailAddressTwo",
		178: "MAIN_CONTENT.ChangeStudentData.emailAddressThree",
		179: "MAIN_CONTENT.ChangeStudentData.birthDate"
	}
};
